<template>
<div class="px-4 sm:px-8 lg:px-0">
    <div class="mx-auto my-12 w-full max-w-[1136px] bg-white rounded-lg px-6 py-12 sm:px-8">
        <div class="flex flex-col items-center text-center text-main">
            <img :src="pendingImg" alt="" class="w-[200px] h-[200px]" />
            <div class="flex flex-col items-center gap-4 py-8 w-full">
                <h1 class="font-bold text-2xl leading-8">チャンネル申請を受け付けました</h1>
                <div class="text-sm leading-5">
                    <p>記事が投稿できるようになりましたら、登録いただいたメールアドレスにお知らせします。</p>
                    <p v-if="applicationEmail" class="break-all">{{ applicationEmail }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import axios from 'axios';
import pendingImg from '@/assets/channel_application_pending.svg';
import {
    CHANNEL_APPLICATION_STATUS_APPROVED,
    CHANNEL_APPLICATION_STATUS_REJECTED,
} from '@/plugins/constants';

const router = useRouter();
const store = useStore();

const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;

const applicationEmail = computed(() => store.state.applicationEmail);

// #301: 現在ステータスを /me/ から取得し、遷移が必要ならルートごと切り替える
const fetchStatus = async () => {
    try {
        const accessToken = store.state.accessToken;
        const response = await axios.get(
            `${apiEndpoint}/channel-applications/me/`,
            {
                headers: { 'Authorization': `Bearer ${accessToken}` },
            }
        );
        const data = response.data;
        store.commit('setApplicationStatus', data.application_status);
        store.commit('setWaitForInvitation', data.wait_for_invitation);
        store.commit('setShowApprovalAlert', data.show_approval_alert);
        if (data.application_email !== undefined) {
            store.commit('setApplicationEmail', data.application_email);
        }

        if (Number(data.application_status) === CHANNEL_APPLICATION_STATUS_APPROVED) {
            router.push({ name: 'ArticleManagement' });
        } else if (Number(data.application_status) === CHANNEL_APPLICATION_STATUS_REJECTED) {
            router.push({ name: 'ChannelApplicationRejected' });
        }
    } catch (error) {
        console.error('申請ステータスの取得に失敗しました。', error);
    }
};

onMounted(() => {
    fetchStatus();
});
</script>
